import React, { useState } from "react";
import { IconButton, TextField } from "@mui/material";
import { Clear, Search } from "@mui/icons-material";
import { t } from "i18next";
import { useScanner } from "../../../../common/hooks/use-scanner";

interface IBtmReturnsListSearchProps {
    value: string;
    onChange: (value: string) => void;
}

export const BtmReturnsListSearch = (props: IBtmReturnsListSearchProps) => {
    const [isFocused, setIsFocused] = useState(false);
    useScanner(props.onChange, !isFocused);

    return <TextField value={props.value}
                      placeholder={t("components.blueBrandReturns.list.quickSearchPlaceholder")}
                      onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                      slotProps={{
                          input: {
                              style: { backgroundColor: "white", width: "463px" },
                              startAdornment: <Search />,
                              endAdornment: props.value ? <IconButton onClick={() => props.onChange("")} color={"error"}>
                                  <Clear />
                              </IconButton> : undefined}}}
                      onKeyDown={event => event.key === "Escape" && props.onChange("")}
                      onChange={event => props.onChange(event.target.value)} />;
};
